import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';

import { FaChevronLeft } from 'react-icons/fa';
import logo_melia from './logo_melia.png';

import './Header.css';

const Header = ({
  title,
  hotelName,
  dirtyIndicator,
  backAction,
  handleModalMessages
}) => {
  const mainBackAction = () => {
    if (backAction !== undefined) {
      backAction();
    } else {
      window.close();
    }
  };

  function checkIsDirty() {
    if (dirtyIndicator) {
      handleModalMessages('atencionModal', 'confirmarSalir', '', 'continuar', mainBackAction, true, 'volver');
    } else {
      mainBackAction();
    }
  }

  return (
    <Container fluid className="main-header-info no-padding">
      <Row className="auto-margin no-padding h-100">
        <Col sm="12" className="no-padding main-title__container">
          <Container className="no-padding">
            <Row className="auto-margin no-padding">
              <Col sm="auto" className="no-padding-left left-head-info">
                <div className="back-button-container">
                  <span className="circle-icon">
                    <FaChevronLeft data-test-id="boton-home" onClick={checkIsDirty} />
                  </span>
                </div>
              </Col>
              <Col sm="3" className="no-padding-right">
                <img data-test-id="logo-melia" src={logo_melia} alt="/logo_melia.png" className="main-logo" />
              </Col>
              <Col sm="auto" className="right-head-info">
                <Row className="auto-margin no-padding justify-content-end">
                  <Col sm="auto" data-test-id="hotel-cabecera" className="hotel-info-name text-uppercase">{hotelName}</Col>
                  <Col sm="auto" data-test-id="titulo-cabecera" className="font-weight-bold">{title}</Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  hotelName: PropTypes.string,
  dirtyIndicator: PropTypes.bool,
  backAction: PropTypes.func,
  handleModalMessages: PropTypes.func
};

Header.defaultProps = {
  hotelName: '',
  dirtyIndicator: false,
  backAction: undefined,
  handleModalMessages: () => {}
};

export default Header;
